import styled from "styled-components";

export const StyledHeader = styled.h1`
  // font-size: calc(22px + (36 - 14) * ((100vw - 300px) / (1600 - 300)));
  font-size: calc(22px + (52 - 14) * ((100vw - 300px) / (1600 - 300)));
  // font-weight: lighter; // this was bold
  text-align: center;
  padding-top: 1vh;
  // font-family: "Dancing Script", cursive;
  // color: #00eb95;
  // orange
  color: #ffbe1c;

  .center {
    margin: auto;
    width: 50%;
    padding: 10px;
  }
`;

export const StyledEditorPick = styled.h2`
  font-size: calc(20px + (36 - 14) * ((100vw - 300px) / (1600 - 300)));
  // font-weight: lighter;
  // text-align: center;
  padding-top: 1vh;
  padding-bottom: 5vh;
  color: #ffbe1c;

  .center {
    margin: auto;
    width: 50%;
    padding: 10px;
  }
`;

export const FaqLine = styled.div`
  background: #cccccc;
  height: 0.2rem;
  margin: 2rem 0rem;
  width: 100%auto;
`;

export const H1 = styled.h1`
  font-size: calc(22px + (32 - 14) * ((100vw - 300px) / (1600 - 300)));
  // font-weight: lighter;
  line-height: 1.3;
  color: #f5f5f5;
`;

export const H2 = styled.h2`
  font-size: calc(20px + (24 - 14) * ((100vw - 300px) / (1600 - 300)));
  //font-weight: lighter;
  line-height: 1.3;
  // Added
  color: #eeeeee;
`;

export const H3 = styled.h3`
  font-size: calc(18px + (18.72 - 14) * ((100vw - 300px) / (1600 - 300)));
  // font-weight: lighter;
  line-height: 1.3;
  // Added
  color: #e0e0e0;
`;

export const H4 = styled.h4`
  font-size: calc(16px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
  // font-weight: lighter;
  line-height: 1.3;
  // Added
  color: #bdbdbd;
`;

export const P = styled.p`
  font-size: calc(16px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
  line-height: 1.3;
  // Added
  // color: white;
  color: #bdbdbd;
`;

export const NBP = styled.p`
  font-size: calc(16px + (16 - 14) * ((100vw - 300px) / (1600 - 300)));
  line-height: 1.3;
  margin-bottom: 0;
  // Added
  // color: white;
  color: #bdbdbd;
`;

export const HR = styled.hr`
  background-color: #9e9e9e;
`;

export default { StyledHeader };
